/* Çã · site.js: o que é da casca e da capa. Entrada da página (classe "ready"), movimento leve ao rolar (paralaxe da
   colagem e da seção escura), cabeçalho que some no celular e o botão da faixa do cupom. Compra, gaveta e carrinho moram
   no ca-compra.js; galeria e acordeões do produto, no ca-produto.js. Cada parte reinicia quando o editor de temas
   recarrega uma seção (shopify:section:load). */
(function(){
  'use strict';
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var narrow=window.matchMedia('(max-width:820px)');

  // entrada: a capa e a colagem aparecem com o fade (site.css, body.ready)
  requestAnimationFrame(function(){requestAnimationFrame(function(){document.body.classList.add('ready');});});

  // movimento leve ao rolar: colagem da capa (data-px = fator do scroll, só em tela larga) e seção escura (data-pp = amplitude em px)
  var px=[],pp=[],hero=null,tick=false,ouvindo=false;
  function frame(){
    tick=false;
    var y=window.pageYOffset||0,vh=window.innerHeight;
    if(hero&&px.length){var off=narrow.matches?0:y;if(off<hero.offsetHeight+vh){px.forEach(function(o){o.el.style.transform='translate3d(0,'+(-off*o.k).toFixed(1)+'px,0)';});}}
    pp.forEach(function(o){var r=o.box.getBoundingClientRect();if(r.bottom<-100||r.top>vh+100)return;var p=Math.min(1,Math.max(0,(vh-r.top)/(vh+r.height)));o.el.style.transform='translate3d(0,'+((p-.5)*o.a).toFixed(1)+'px,0)';});
  }
  function ask(){if(!tick){tick=true;requestAnimationFrame(frame);}}
  function iniciarMovimento(){
    if(reduce)return;
    px=[].slice.call(document.querySelectorAll('[data-px]')).map(function(el){return {el:el.querySelector('.pxw')||el.querySelector('img')||el,k:parseFloat(el.getAttribute('data-px'))||0};});
    pp=[].slice.call(document.querySelectorAll('[data-pp]')).map(function(el){return {el:el,a:parseFloat(el.getAttribute('data-pp'))||0,box:el.parentNode};});
    hero=document.querySelector('.hero');
    if((px.length||pp.length)&&!ouvindo){window.addEventListener('scroll',ask,{passive:true});window.addEventListener('resize',ask);ouvindo=true;}
    if(px.length||pp.length)frame();
  }

  // celular e tablet em pé: o cabeçalho (menu completo, duas linhas no celular) some ao rolar para baixo e volta ao rolar para cima.
  // O .hd é procurado a cada rolagem, para seguir valendo depois que o editor recarrega a seção do cabeçalho.
  var lastY=window.pageYOffset||0;
  window.addEventListener('scroll',function(){
    var hd=document.querySelector('.hd'),y=window.pageYOffset||0;
    if(!hd){lastY=y;return;}
    if(!narrow.matches){hd.classList.remove('off');lastY=y;return;}
    if(y>lastY+6&&y>160)hd.classList.add('off');else if(y<lastY-6||y<=160)hd.classList.remove('off');
    lastY=y;
  },{passive:true});
  // quem usa o teclado nunca fica sem o cabeçalho: foco dentro dele o traz de volta
  document.addEventListener('focusin',function(e){var hd=document.querySelector('.hd');if(hd&&hd.contains(e.target))hd.classList.remove('off');});

  // faixa do cupom: o botão põe a caixa avulsa no carrinho (/cart/add.js) e segue para /discount/CÓDIGO?redirect=/cart,
  // que aplica o cupom e abre o carrinho. Se a caixa avulsa já estiver lá (o carrinho pode ter mudado pela gaveta depois de
  // a página abrir), só aplica o cupom, para não somar outra caixa. A linha da assinatura não conta (o cupom não vale
  // nela). Se algo falhar ou demorar, segue o link da página (cupom + produto).
  function iniciarFaixa(raiz){
    [].slice.call((raiz||document).querySelectorAll('[data-ca-aviso][data-ca-variante]')).forEach(function(a){
      if(a.getAttribute('data-ca-pronto'))return;
      a.setAttribute('data-ca-pronto','1');
      a.addEventListener('click',function(ev){
        if(ev.metaKey||ev.ctrlKey||ev.shiftKey||ev.altKey||ev.button)return;
        if(!window.fetch)return;
        var vid=a.getAttribute('data-ca-variante'),com=a.getAttribute('data-ca-com-caixa');
        if(!vid||!com)return;
        ev.preventDefault();
        if(a.getAttribute('aria-busy'))return;
        a.setAttribute('aria-busy','true');
        var raizLoja=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
        var foi=false,ir=function(u){if(!foi){foi=true;window.location.href=u;}};
        setTimeout(function(){ir(a.href);},6000); // se o carrinho não responder, segue o link que a página trouxe
        fetch(raizLoja+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json'}})
          .then(function(r){return r.json();})
          .then(function(c){
            var tem=(c.items||[]).some(function(i){return String(i.variant_id)===vid&&!i.selling_plan_allocation;});
            if(tem)return;
            return fetch(raizLoja+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(vid),quantity:1}]})});
          })
          .then(function(){ir(com);})
          .catch(function(){ir(a.href);});
      });
    });
  }

  function iniciar(raiz){iniciarMovimento();iniciarFaixa(raiz);}
  iniciar(document);
  document.addEventListener('shopify:section:load',function(e){iniciar(e.target);});
  document.addEventListener('shopify:section:unload',function(){setTimeout(iniciarMovimento,0);});
})();
